import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { intl } from "LocaleWrapper";
import { ContactRoleType } from "__generated__/enums";

const CharterContactRoleTypeSelect = <Multiple extends boolean = false,>({
	value,
	onChange,
	multiple,
}: Omit<SelectProps<ContactRoleType, Multiple>, "fetchOptions">) => {
	const contactRoles = [ ContactRoleType.OrderEntry, ...Object.values(ContactRoleType).filter(x => x !== ContactRoleType.OrderEntry) ];

	return (
		<Select
			fetchOptions={contactRoles}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			value={value}
			onChange={onChange}
			multiple={multiple} />
	);
};

export default CharterContactRoleTypeSelect;
